import styled from 'styled-components';
import { media } from '../../styles/media';

export const Description = styled.p`
  font-size: clamp(16px, 2vw, 18px);
  line-height: 1.6;
  color: #666;
  max-width: 800px;
  margin: 0 auto 48px;
  text-align: center;
  
  ${media.md`
    font-size: 16px;
    margin-bottom: 32px;
    padding: 0 20px;
  `}
`; 